import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const navLinks = [
    { labelKey: "nav.home", path: "/" },
    { labelKey: "nav.services", path: "/services" },
    { labelKey: "nav.about", path: "/about" },
    { labelKey: "nav.contact", path: "/contact" },
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-slate-700">
          <div className="md:col-span-1">
            <div className="flex items-baseline mb-4">
              <span className="text-2xl font-extrabold tracking-tight text-emerald-400" style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.01em" }}>
                Medi<span className="text-white">Green</span>
              </span>
              <span className="ml-2 text-xs font-semibold tracking-widest uppercase text-slate-500" style={{ fontFamily: "'Inter', sans-serif" }}>LLC</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">{t("footer.brand.desc")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-300 mb-5">{t("footer.nav.title")}</h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-slate-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                    {t(link.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-300 mb-5">{t("footer.contact.title")}</h4>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5"><i className="ri-map-pin-line text-emerald-500" /></div>
                <span style={{ whiteSpace: "pre-line" }}>{t("footer.address")}</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-line text-emerald-500" /></div>
                <a href="tel:+16714820104" className="hover:text-emerald-400 transition-colors">{t("footer.phone")}</a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line text-emerald-500" /></div>
                <a href="mailto:info@medigreen.energy" className="hover:text-emerald-400 transition-colors">{t("footer.email")}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-sm text-slate-500">
          <p>{t("footer.copyright")}</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-slate-300 transition-colors cursor-pointer">{t("footer.privacy")}</Link>
            <Link to="/terms" className="hover:text-slate-300 transition-colors cursor-pointer">{t("footer.terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
